function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { ButtonGroup, Size, breakpoints, useWindowDimensions } from '@soluto-private/mx-asurion-ui-react';
const ModalButtonGroup = styled(ButtonGroup).withConfig({
  displayName: "ModalButtonGroup",
  componentId: "asurion-ui-react__sc-11qnfwn-0"
})(["padding:0 1rem 1rem 1rem;", "{padding:0 1.5rem 1.5rem 1.5rem;}"], breakpoints.md);
export const Footer = /*#__PURE__*/React.forwardRef(({
  children,
  ...rest
}, fRef) => {
  const {
    width
  } = useWindowDimensions();
  return /*#__PURE__*/React.createElement(ModalButtonGroup, _extends({
    ref: fRef,
    alignment: "end",
    isStacked: width < Size.MD,
    hasFullWidthButtons: width < Size.MD
  }, rest), children);
});